var __jsx = React.createElement;
import React from "react";
import { BottomSheet } from "@componentsShared/BottomSheet";
import { Drawer, DrawerClose, DrawerContent, DrawerHeader } from "@/components/Drawer";
import { Icon } from "@syarahtech/ui";
import useIsMobile from "@hooks/useIsMobile";
import { Conditional } from "@componentsShared/Conditional/Conditional";
import { Then } from "@componentsShared/Conditional/Then";
import { Else } from "@componentsShared/Conditional/Else";
import { CDN_LINK } from "@globalConfig";
import { useTranslation } from "@i18n";
var ContactModalContent = function ContactModalContent(_ref) {
  var title = _ref.title,
    phoneNumber = _ref.phoneNumber;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t,
    tShort = _useTranslation.tShort;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-4 p-8"
  }, /*#__PURE__*/React.createElement("h4", {
    className: "font-cairo text-2xl font-bold leading-6 text-[#154F9C] mb-9 text-center"
  }, title), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-row sm:flex-col gap-4 w-full"
  }, /*#__PURE__*/React.createElement("a", {
    href: "tel:" + phoneNumber,
    className: "flex-1 sm:w-full bg-[#154F9C] rounded text-white text-sm font-bold leading-6 text-center p-[15px] flex  justify-center  items-center gap-[10px] hover:text-white transition-colors"
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/CallTM.svg",
    alt: "phone"
  }), /*#__PURE__*/React.createElement("p", {
    className: "text-white text-sm font-bold"
  }, tShort("dhamen/call"))), /*#__PURE__*/React.createElement("a", {
    href: "https://wa.me/+966" + phoneNumber,
    className: "flex-1 sm:w-full bg-[#00B362] rounded text-white text-sm font-bold leading-6 text-start p-[15px] flex justify-center  items-center gap-[10px] hover:text-white transition-colors"
  }, /*#__PURE__*/React.createElement("img", {
    width: "20px",
    src: CDN_LINK + "/assets/images/whTM.svg",
    alt: "whatsapp"
  }), /*#__PURE__*/React.createElement("p", {
    className: "text-white text-sm font-bold"
  }, tShort("dhamen/whatsapp")))));
};
function ContactModal(_ref2) {
  var open = _ref2.open,
    onClose = _ref2.onClose,
    toggle = _ref2.toggle,
    title = _ref2.title,
    phoneNumber = _ref2.phoneNumber;
  var isMobile = useIsMobile();
  return /*#__PURE__*/React.createElement(Conditional, {
    condition: !isMobile
  }, /*#__PURE__*/React.createElement(Then, null, /*#__PURE__*/React.createElement(BottomSheet, {
    open: open,
    onOpen: function onOpen() {},
    onClose: onClose,
    maxHeight: "40%",
    maxHeightDesktop: "40%",
    hideTitleBar: true,
    screens: [{
      title: "",
      component: /*#__PURE__*/React.createElement(ContactModalContent, {
        title: title,
        phoneNumber: phoneNumber
      })
    }]
  })), /*#__PURE__*/React.createElement(Else, null, /*#__PURE__*/React.createElement("div", {
    className: "bg-white"
  }, /*#__PURE__*/React.createElement(Drawer, {
    open: open,
    onOpenChange: toggle,
    repositionInputs: false,
    preventScrollRestoration: true
  }, /*#__PURE__*/React.createElement(DrawerContent, {
    className: "max-h-[110vh] z-[9999999]"
  }, /*#__PURE__*/React.createElement(DrawerHeader, {
    className: "bg-white p-0 rounded-t-lg"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center px-3 py-4 justify-end"
  }, /*#__PURE__*/React.createElement(DrawerClose, {
    asChild: true
  }, /*#__PURE__*/React.createElement("button", {
    className: "p-0 rounded-full bg-transparent outline-none border-none w-6 h-6"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--close-small-outline-rounded",
    className: "text-gray-text",
    height: 6,
    width: 6
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "overflow-y-auto flex-1 max-h-fit bg-white"
  }, /*#__PURE__*/React.createElement(ContactModalContent, {
    title: title,
    phoneNumber: phoneNumber
  })))))));
}
export default ContactModal;